import ResponsiveMenu from "./ResponsiveMenu";
import ButtonsContainer from "./ButtonsContainer";
import classes from "./classes.module.scss";
import TitleContainer from "./TitleContainer";
import { useState } from "react";

export default function ProfessionalSpaceHeader() {
	const [isEditing, setIsEditing] = useState(false);

	return (
		<header className={classes["root"]}>
			<TitleContainer isEditing={isEditing} setIsEditing={setIsEditing} />
			<ButtonsContainer className={classes["buttons-container-root"]} subClassName={classes["buttons-container-subroot"]} />
			{!isEditing && <ResponsiveMenu />}
		</header>
	);
}
